import { useFlags } from "launchdarkly-react-client-sdk";

/** Whether skills written as steps are on for this workspace. */
export function useDagSkillsEnabled(): boolean {
  const { ampDagSkills } = useFlags();
  return ampDagSkills === true;
}
